import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export function useViewSize() {
  var ref = useRef(null);
  var [size, setSize] = useState({
    width: 0,
    height: 0
  });

  // Prevent too many rendering using useCallback
  var handleSize = useCallback(element => {
    if (element.offsetWidth !== size.width || element.offsetHeight !== size.height) {
      setSize({
        width: element.offsetWidth || size.width,
        height: element.offsetHeight || size.height
      });
    }
  }, [size.width, size.height]);
  var savedHandler = useRef(handleSize);
  useIsomorphicLayoutEffect(() => {
    savedHandler.current = handleSize;
  }, [handleSize]);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    var eventListener = () => {
      if (ref.current) {
        savedHandler.current(ref.current);
      }
    };
    window.addEventListener('resize', eventListener);
    return () => {
      window.removeEventListener('resize', eventListener);
    };
  }, []);
  useIsomorphicLayoutEffect(() => {
    if (!ref.current) {
      return;
    }
    var RO = new ResizeObserver(entries => {
      var entry = entries[0].target;
      handleSize(entry);
    });
    RO.observe(ref.current);
    return () => {
      RO.disconnect();
    };
  }, [ref.current, handleSize]);
  useIsomorphicLayoutEffect(() => {
    if (ref.current) {
      handleSize(ref.current);
    }
  }, [ref.current, handleSize]);
  return [{
    onRef: ref
  }, size];
}
//# sourceMappingURL=index.js.map